import classNames from 'classnames';
import { ReactNode } from 'react';
import styled from 'styled-components';

import ButtonBase from '@sorare/core/src/atoms/buttons/ButtonBase';
import { FullViewportScroll } from '@sorare/core/src/atoms/container/FullViewportScroll';
import { BodyM } from '@sorare/core/src/atoms/typography';
import { tabletAndAbove } from '@sorare/core/src/style/mediaQuery';

const Root = styled.div`
  background-color: var(--c-neutral-100);
  padding: var(--double-unit) 0;
  @media ${tabletAndAbove} {
    padding: var(--double-unit) 0;
  }
`;
const Filter = styled(FullViewportScroll)`
  display: flex;
  gap: var(--half-unit);
  align-self: normal;
  padding: var(--double-unit) 0;
`;

const FilterItem = styled(ButtonBase)`
  padding: var(--half-unit) var(--double-unit);
  border-radius: var(--unit);
  transition: background-color 0.2s ease-in-out;
  border: 1px solid var(--c-neutral-400);
  &.selected {
    background-color: var(--c-neutral-400);
  }
`;
const FilterLabel = styled(BodyM)`
  white-space: nowrap;
`;

export type Props<
  T extends {
    value: string;
    label: ReactNode;
  },
> = {
  options: T[];
  selected: T;
  onChange: (s: T) => void;
};

export const Filters = <
  T extends {
    value: string;
    label: ReactNode;
  },
>({
  options,
  selected,
  onChange,
}: Props<T>) => {
  return (
    <Root>
      <Filter>
        {options.map(option => (
          <FilterItem
            key={option.value}
            onClick={() => onChange(option)}
            className={classNames({
              selected: option.value === selected.value,
            })}
          >
            <FilterLabel as="span" bold>
              {option.label}
            </FilterLabel>
          </FilterItem>
        ))}
      </Filter>
    </Root>
  );
};
